import { ForecastRatioVolumeOuomTypeBase } from './base/forecast-ratio-volume-ouom-type-base';

export class ForecastRatioVolumeOuomType extends ForecastRatioVolumeOuomTypeBase { }